import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const ComplimentryService = {
  getAll: async ({ startDate, endDate, productId }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (productId) params.append("productId", productId);

    const response = await apiService.get(
      `/${slug}/complimentrylogs/all?${params.toString()}`
    );

    return response.data;
  },
  getOrderwise: async ({ startDate, endDate }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await apiService.get(
      `/${slug}/complimentrylogs/orderwise?${params.toString()}`
    );

    return response.data;
  },
  getGrpItem: async ({ startDate, endDate }) => {
    // Build query params dynamically
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    const response = await apiService.get(
      `/${slug}/complimentrylogs/group-by-items?${params.toString()}`
    );

    return response.data;
  },

  detail: async (orderId) => {
    const response = await apiService.get(
      `/${slug}/complimentrylogs/details/${orderId}`
    );
    return response.data;
  },
};

export default ComplimentryService;
